import React from 'react'
import * as S from './styled'

export const NoSearchResult = () => <S.TextNoResult>Nenhum resultado encontrado.</S.TextNoResult>
